<cui-accordion>
  <cui-accordion-item class="mb-bl-2" data-pgr-id="uwMemoLandingExpansionPanel">
    <cui-accordion-header>
      <cla-uw-memo-landing-header
        [underwritingMemos]="underwritingMemos$ | async"
        [claimNumber]="claimNumber"
        class="w-full"
      ></cla-uw-memo-landing-header>
    </cui-accordion-header>
    <cui-accordion-body>
      <cla-uw-memo-landing-overview
        [underwritingMemos]="underwritingMemos$ | async"
        [userId]="userId"
      >
      </cla-uw-memo-landing-overview>
    </cui-accordion-body>
  </cui-accordion-item>
</cui-accordion>
